import { ChildrenNode, Matcher, MatchResponse, Node } from "interweave"
import { escapeRegExp } from "lodash"

export class SearchHighlightMatcher extends Matcher<{ found: string }> {
  private expression: RegExp
  constructor(terms: string[]) {
    super("searchHighlight")
    const alternatives = [...new Set(terms.filter(Boolean))]
      .sort((a, b) => b.length - a.length)
      .map((term) => term.split(/\s+/).map(escapeRegExp).join("\\s+"))
    this.expression = new RegExp(
      alternatives.length ? alternatives.join("|") : "(?!)",
      "i",
    )
  }
  match(text: string): MatchResponse<{ found: string }> | null {
    const result = this.expression.exec(text)
    return result
      ? {
          index: result.index,
          length: result[0].length,
          match: result[0],
          found: result[0],
          valid: true,
        }
      : null
  }
  replaceWith(
    children: ChildrenNode,
    props: { found: string; key?: string | number },
  ): Node {
    return (
      <mark
        key={props.key}
        className="rounded-sm bg-primary/15 px-0.5 text-foreground"
      >
        {children}
      </mark>
    )
  }
  asTag(): string {
    return "mark"
  }
}
